import config from "../config";

export interface EventPayload {
    isDelayed?: boolean;
    eventTypeKey: string;
    keyValue: string;
    params: { name: string; value: string | Date }[];
}

export function sendEventBeacon({ eventTypeKey, keyValue, params, isDelayed = false }: EventPayload): boolean {
    const url = `${config.API_URL}/mtpl/event${isDelayed ? '?delay=true' : ''}`;

    const data = JSON.stringify({
        eventTypeKey,
        keyValue,
        params,
    });

    const blob = new Blob([data], { type: 'application/json' });

    return navigator.sendBeacon(url, blob);
}
